module.exports = __webpack_public_path__ + "img/富山春.ea399a66.jpg";